import React, {Fragment} from "react"
import ContentLoader from "react-content-loader" 
import { Grid, Hidden, Container, Icon, Typography, Button, Paper, Card, CardHeader, CardContent } from '@material-ui/core'
//import config from "./../store/config/config.json";
import CircularProgress from '@material-ui/core/CircularProgress';
import Image from './Image'

export default function Preload() {
    return (
        <Fragment>
            <main className="main_content preload preload-common">
                <div className="container-preload-image">
                    <div className="inner-preload-image">
                        <Grid container spacing={2}>
                            <Grid item md={12}>
                                <div className="text-center">
                                    <CircularProgress />
                                    <h2 className="title">Estamos procesando tu consulta</h2>
                                </div>
                            </Grid>
                        </Grid>
                    </div>
                </div>
                <div className="page-maxwidth">
                    <Container maxWidth="xl">
                        <Grid container spacing={1}>
                            <Grid item md={9}>
                                <Paper className="breadcrumbs-leyend" elevation={0}>
                                    <Grid container spacing={0}>
                                        <Grid item md={6}>
                                        <div className="breadcrumb">
                                            <Typography variant="body2"><span>Inicio</span> <Icon>chevron_right</Icon> <span>Trenes</span> <Icon>chevron_right</Icon> <span>Resultados</span></Typography> 
                                        </div>  
                                        </Grid>
                                        <Grid item md={6}>
                                            <div className="leyend">
                                                <form>
                                                <Typography display="inline" variant="body2">Filtra tu busqueda:</Typography>
                                                <Button size="small" variant="contained" className="btn-filter">&nbsp;</Button>
                                                <Button size="small" variant="contained" className="btn-filter">&nbsp;</Button>
                                                <Button size="small" variant="contained" className="btn-filter">&nbsp;</Button>
                                                </form>
                                            </div>
                                        </Grid>
                                    </Grid>
                                </Paper>
                                <div className="ContainerSegment">
                                    <div className="tabSegmentTitle">
                                        <ContentLoader speed={2} title="" backgroundColor="#d1d1d1" foregroundColor="#e1e1e1" 
                                            width={200} 
                                            height={20} 
                                            viewBox="0 0 200 20" >
                                            <rect x="0" y="0" rx="5" ry="5" width="200" height="20" />
                                        </ContentLoader>
                                    </div>
                                    <div className="tabSegmentPanel empty">
                                        <div className="title">
                                            <ContentLoader speed={2} title="" backgroundColor="#d1d1d1" foregroundColor="#e1e1e1" 
                                                width={450} 
                                                height={30} 
                                                viewBox="0 0 450 30" >
                                                <circle cx="15" cy="15" r="15" /> 
                                                <rect x="35" y="0" rx="5" ry="5" width="395" height="30" />
                                            </ContentLoader>
                                        </div>

                                        <div className="responsive">
                                            <ContentLoader speed={2} title="" backgroundColor="#d1d1d1" foregroundColor="#e1e1e1" 
                                                width={450}
                                                height={100}
                                                viewBox="0 0 450 100">
                                                <rect x="0" y="0" rx="5" ry="5" width="450" height="90" />
                                            </ContentLoader>
                                        </div>
                                    </div>
                                </div>
                            </Grid>
                            <Hidden smDown>
                                <Grid item md={3}>
                                    <Card className="card-detail-rate">
                                        <CardHeader className="card-header" title={<Fragment> 
                                            <div className="tarifa-head inverse">
                                                <div className="content">       
                                                    <Typography variant="h3" className="title">No hay opción seleccionada</Typography>
                                                    <Typography>Seleccione una opción para continuar</Typography>
                                                </div>
                                            </div>                            
                                        </Fragment>}/>

                                        <CardContent className="card-content">
                                            <Fragment>
                                                <div className="btnResume">
                                                    <Button fullWidth variant="contained" color="primary" disabled>Reservar</Button>
                                                </div>
                                                <div className="image py-4 text-center">
                                                    <Image img={`ticket.png`} alt="No hay tickets seleccionados" /> 
                                                </div>
                                            </Fragment>  
                                    </CardContent>
                                    </Card>
                                </Grid>
                            </Hidden>
                        </Grid>
                    </Container>
                </div>
            </main>
        </Fragment>
    )
}
